import * as React from "react";
import { callApi } from "../../utils/api";
import { ToastsStore } from "react-toasts";
import Select from "react-select";
import "./Dashboard.css";
import DatePicker from "antd/lib/date-picker";
import moment from "moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import axios from "axios";
import { MdOutlineRefresh } from "react-icons/md";
import { ADMIN_ROLE } from "../../utils/role";
import { hasPageAccess } from "../../utils/pagePermissionService";
import { FileCopyOutlined } from "@material-ui/icons";
// import WorkCountTable from "./Workcounttable";
declare var $: any;

interface AllProps {
  match: any;
  history: any;
  router: any;
  route: any;
}

// Define tab configuration
interface TabConfig {
  id: string;
  label: string;
  component: string;
  apiEndpoint?: string;
  requiresData?: boolean;
  allowedRoles?: string[]; // Which roles can see this report
}

// Session storage key constant - now include user-specific key
const getStorageKey = () => {
  const user: any = localStorage.getItem("user");
  if (user) {
    const userDetails = JSON.parse(user);
    return `dashboard_selected_tabs_${userDetails.userId}`;
  }
  return 'dashboard_selected_tabs';
};

class Dashboard extends React.Component<AllProps> {
  // Define all available tabs with role-based visibility
  tabsConfig: TabConfig[] = [
    {
      id: 'eod', label: 'Login Report', component: 'eod', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    }, // All roles
    {
      id: 'queryValidation', label: 'Query Validation', component: 'queryValidation', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    }, // Admin, Manager, Team Lead
    {
      id: 'queryMail', label: 'Received Query Via Mail', component: 'queryMail', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    },
    {
      id: 'vetting', label: 'Vetting Report', component: 'vetting', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    }, // Only Admin and Manager
    {
      id: 'deviationTracker', label: 'Deviation Tracker', component: 'deviationTracker', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    },
    {
      id: 'rectification', label: 'Rectification Report', component: 'rectification', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    },
    {
      id: 'deviation', label: 'Deviation Report', component: 'deviation', requiresData: true,
      allowedRoles: ['1', '2', '3', '4']
    },
    {
      id: 'myTeam', label: 'My Team Workfile', component: 'myTeam', requiresData: true,
      allowedRoles: ['1', '2']
    },
    {
      id: 'branchLogin', label: 'Branch wise Login Report', component: 'branchLogin', requiresData: true,
      allowedRoles: ['1', '2']
    }, // Only Admin and Manager
    {
      id: 'teamTracking', label: 'Team Wise Tracking', component: 'teamTracking', requiresData: true,
      allowedRoles: ['1', '2']
    },
    {
      id: 'fileGrade', label: 'Process Wise Tracking', component: 'fileGrade', requiresData: true,
      allowedRoles: ['1', '2']
    },
  ];

  // Default tabs (only Login Report)
  defaultTabs = ['eod'];

  // Get current user details
  getCurrentUser = () => {
    const user: any = localStorage.getItem("user");
    return user ? JSON.parse(user) : null;
  };

  // Get tabs visible for current user role
  getVisibleTabsForCurrentRole = () => {
    const userDetails = this.getCurrentUser();
    if (!userDetails) return this.tabsConfig;

    const userRoleId = userDetails.role_id;

    // Filter tabs based on allowed roles
    return this.tabsConfig.filter(tab => {
      if (tab.allowedRoles) {
        return tab.allowedRoles.includes(userRoleId);
      }
      return true; // If no allowedRoles defined, show to everyone
    });
  };

  state = {
    lhBranchShow: false,
    bankBranch: false,
    activeTab: "teamTracking",
    // Multi-select state for visible tabs - load from user-specific session storage
    selectedTabs: this.loadSelectedTabsFromStorage(),
    queueDropdownVisible: false,
    selectedUserId: null,
    queueData: {},
    queueLoading: false,
    fileTeamTrakingData: {},
    branchName: false,
    productName: false,
    lawBranchName: false,
    showBank: false,
    expandedUserId: null,
    bankName: false,
    outreason: "",
    selectVal: false,
    overview: [],
    employees: [],
    branchInfo: [],
    branches: [],
    products: [],
    filteredProduct: [],
    filteredBranchesproduct: [],
    fromdate: "",
    eodDate: "",
    eodFromDate: "",
    eodToDate: "",
    todate: "",
    branch: "",
    eodReportTypes: [
      {
        id: 1,
        label: "Branch",
        value: "Branch",
      },
      {
        id: 2,
        label: "Employee",
        value: "Employee",
      },
    ],
    eodData: [],
    queryMailData: [],
    queryValidationData: [],
    vettingData: [],
    deviationData: [],
    rectificationData: [],
    deviationTakeData: [],
    branchEodData: [],
    eodReportType: "Branch",
    eodEmployeeList: [],
    eodEmployee: "",
    lawhandsBranches: [],
    bank_private_name: "",
    banks: [],
    filteredBranches: [],
    lawHandsBranch: "",
    isAllLawHandsBranchSelected: false,
    product_id: "",
    isDateSearchClicked: false,
    myteamdetails: true,
    teamDetailsData: [],
    autoAssign: [
      {
        id: "1",
        module_name: "Auto Assign",
        status: false,
      },
    ],
    isLoading: false,
    isSearchLoading: false,
    teamTrakingData: {},
    showTeamTracking: false,
    presentUsers: [],
    searchQuery: "",
    pageDynamic: [],
    showWorkingNonWorkingSection: false,
    // Track which tabs have loaded data
    loadedTabs: new Set<string>(),
    // Store visible tabs for current user
    visibleTabs: this.getVisibleTabsForCurrentRole(),
  };

  getLawHandsBranchOptions = () => {
    const branchOptions = (this.state.lawhandsBranches || []).map((opt: any) => ({
      ...opt,
      label: opt.name,
      value: String(opt.id),
    }));
    return [{ label: "All", value: "all" }, ...branchOptions];
  };

  getAllLawHandsBranchIds = (): string[] => {
    return (this.state.lawhandsBranches || []).map((item: any) => String(item.id));
  };

  getSelectedLawHandsBranchOptions = () => {
    const selected = this.state.lawHandsBranch
      ? String(this.state.lawHandsBranch).split(",").filter(Boolean)
      : [];
    if (!selected.length) return [];

    const allIds = this.getAllLawHandsBranchIds();
    const options = this.getLawHandsBranchOptions();
    const selectedSet = new Set(selected);
    const isAllSelected =
      allIds.length > 0 && allIds.every((id) => selectedSet.has(id));

    if (this.state.isAllLawHandsBranchSelected || isAllSelected) {
      const allOption = options.find((opt: any) => opt.value === "all");
      return allOption ? [allOption] : [];
    }
    const selectedBranchOptions = options.filter(
      (opt: any) => opt.value !== "all" && selectedSet.has(String(opt.value)),
    );
    return selectedBranchOptions;
  };

  getBranchPayloadValue = () => {
    return this.state.isAllLawHandsBranchSelected ? "" : this.state.lawHandsBranch;
  };

  normalizeFilterPayloadValue = (value: any) => {
    return value === "all" ? "" : value;
  };

  getBankOptions = () => {
    const options = (this.state.banks || []).map((opt: any) => ({
      ...opt,
      label: opt.name,
      value: opt.id,
    }));
    return [{ label: "All", value: "all" }, ...options];
  };

  getProductOptions = () => {
    if (this.state.bank_private_name === "all") {
      return [{ label: "All", value: "all" }];
    }
    const options = (this.state.filteredProduct || []).map((opt: any) => ({
      ...opt,
      label: opt.product_name,
      value: opt.id,
    }));
    return [{ label: "All", value: "all" }, ...options];
  };

  getBankBranchOptions = () => {
    if (this.state.bank_private_name === "all" || this.state.product_id === "all") {
      return [{ label: "All", value: "all" }];
    }
    const options = (this.state.filteredBranches || []).map((opt: any) => ({
      ...opt,
      label: opt.name,
      value: opt.id,
    }));
    return [{ label: "All", value: "all" }, ...options];
  };

  // Helper method to load selected tabs from user-specific session storage
  // Helper method to load selected tabs from user-specific session storage
  loadSelectedTabsFromStorage(): string[] {
    try {
      const user = this.getCurrentUser();
      const storageKey = user ? `dashboard_selected_tabs_${user.userId}` : 'dashboard_selected_tabs';
      const stored = sessionStorage.getItem(storageKey);
      const visibleTabs = this.getVisibleTabsForCurrentRole();
      const visibleTabIds = visibleTabs.map(tab => tab.id);

      if (stored) {
        const parsed = JSON.parse(stored);
        // Validate that stored values are valid tab IDs AND visible to current user
        if (Array.isArray(parsed) && parsed.length > 0) {
          const validTabs = parsed.filter(id =>
            visibleTabIds.includes(id)
          );
          if (validTabs.length > 0) {
            return validTabs;
          }
        }
      }
    } catch (error) {
      console.error('Error loading selected tabs from session storage:', error);
    }

    // Default fallback logic (inline instead of calling another method)
    const visibleTabs = this.getVisibleTabsForCurrentRole();
    if (visibleTabs.some(tab => tab.id === 'eod')) {
      return ['eod'];
    } else if (visibleTabs.length > 0) {
      return [visibleTabs[0].id];
    }
    return [];
  }

  // Get default tabs based on role
  getDefaultTabsForRole = (): string[] => {
    const visibleTabs = this.getVisibleTabsForCurrentRole();

    // Always include 'eod' if visible, otherwise first visible tab
    if (visibleTabs.some(tab => tab.id === 'eod')) {
      return ['eod'];
    } else if (visibleTabs.length > 0) {
      return [visibleTabs[0].id];
    }
    return [];
  };

  // Helper method to save selected tabs to user-specific session storage
  saveSelectedTabsToStorage(tabs: string[]): void {
    try {
      const storageKey = getStorageKey();
      sessionStorage.setItem(storageKey, JSON.stringify(tabs));
    } catch (error) {
      console.error('Error saving selected tabs to session storage:', error);
    }
  }

  // Check if user should see tab selector (now all users can see it, but with filtered options)
  shouldShowTabSelector = () => {
    const visibleTabs = this.getVisibleTabsForCurrentRole();
    return visibleTabs.length > 1; // Show if user has more than one report option
  };

  tableDetails: any;


  async componentDidMount() {
    $(".datepicker").on("change", this.handleChange);

    // Load only the selected tabs data (from session storage or default)
    this.loadVisibleTabsData();

    this.getPageDynamicData();
    this.getOutTime();

    const hasHide = await hasPageAccess("In-Reason/Out-Reason Hide");
    if (!hasHide) {
      this.ouTime();
    }
  }

  // Method to fetch queue data for a specific user
  fetchUserQueue = (userId) => {
    if (!userId) return;

    this.setState({ queueLoading: true, queueData: { data: [], Completed_file_count: 0 } });

    const obj = {
      user_id: userId
    };

    callApi("POST", "file_position_tracking.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({
          queueData: result || { data: [], Completed_file_count: 0 },
          queueLoading: false
        });
      })
      .catch((err) => {
        console.log("Error fetching queue data:", err);
        this.setState({ queueLoading: false });
        ToastsStore.error("Failed to load queue data");
      });
  };

  // Method to toggle queue dropdown
  toggleQueueDropdown = (userId, event) => {
    event.stopPropagation(); // Prevent event bubbling

    const { selectedUserId, queueDropdownVisible } = this.state;

    // If clicking on the same user, just toggle visibility
    if (selectedUserId === userId && queueDropdownVisible) {
      this.setState({ queueDropdownVisible: false });
    } else {
      // New user selected, fetch data and show dropdown
      this.setState({
        selectedUserId: userId,
        queueDropdownVisible: true
      }, () => {
        this.fetchUserQueue(userId);
      });
    }
  };

  // Load data for visible tabs only (based on selectedTabs)
  loadVisibleTabsData = async () => {
    const { selectedTabs, loadedTabs } = this.state;
    const visibleTabs = this.getVisibleTabsForCurrentRole();
    const visibleTabIds = visibleTabs.map(tab => tab.id);
    const loadPromises: Promise<any>[] = [];

    selectedTabs.forEach(tabId => {
      // Only load if tab is visible for current role
      if (visibleTabIds.includes(tabId) && !loadedTabs.has(tabId)) {
        loadPromises.push(this.loadTabData(tabId));
      }
    });

    await Promise.all(loadPromises);
  };

  // Load data for specific tab
  loadTabData = (tabId: string): Promise<any> => {
    const { loadedTabs, eodFromDate, eodToDate, lawHandsBranch, bank_private_name, product_id, branch } = this.state;

    if (loadedTabs.has(tabId)) return Promise.resolve(); // Already loaded

    const obj = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
    };

    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";

    const apiObj = {
      ...obj,
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };

    let apiCall: Promise<any> = Promise.resolve();

    switch (tabId) {
      case 'eod':
        if (this.state.eodData.length === 0) {
          apiCall = callApi("POST", "main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({
                eodData: result.data,
                queryMailData: result.queryMailData
              });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'queryValidation':
        if (this.state.queryValidationData.length === 0) {
          apiCall = callApi("POST", "query_validation_main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ queryValidationData: result.data || [] });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'queryMail':
        // queryMailData is loaded with eod data
        if (this.state.queryMailData.length === 0 && this.state.eodData.length === 0) {
          // If not loaded with eod, fetch separately
          apiCall = callApi("POST", "main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ queryMailData: result.queryMailData || [] });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'vetting':
        if (this.state.vettingData.length === 0) {
          apiCall = callApi("POST", "vetting_main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ vettingData: result.data });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'deviationTracker':
        if (this.state.deviationTakeData.length === 0) {
          apiCall = callApi("POST", "deviation_take_main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ deviationTakeData: result.data });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'rectification':
        if (this.state.rectificationData.length === 0) {
          apiCall = callApi("POST", "rectification_main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ rectificationData: result.data });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'deviation':
        if (this.state.deviationData.length === 0) {
          apiCall = callApi("POST", "deviation_main_report.php", apiObj)
            .then((res) => res.data)
            .then((result) => {
              this.setState({ deviationData: result.data });
            })
            .catch((err) => console.log(err));
        }
        break;

      case 'myTeam':
        if (this.state.teamDetailsData.length === 0) {
          apiCall = Promise.resolve(this.getteamdetailsTableData());
        }
        break;

      case 'branchLogin':
        if (this.state.branchEodData.length === 0) {
          apiCall = Promise.resolve(this.getBranchEodData());
        }
        break;

      case 'teamTracking':
        if (Object.keys(this.state.teamTrakingData).length === 0) {
          apiCall = Promise.resolve(this.getTeamTrackingTableData());
        }
        break;

      case 'fileGrade':
        if (Object.keys(this.state.fileTeamTrakingData).length === 0) {
          apiCall = Promise.resolve(this.getFileTeamTrackingTableData());
        }
        break;
    }

    // Mark tab as loaded
    this.setState((prevState: any) => ({
      loadedTabs: new Set(prevState.loadedTabs).add(tabId)
    }));

    return apiCall;
  };

  // Handle tab selection change
  handleTabSelectionChange = (selectedOptions: any) => {
    const selectedValues = selectedOptions ? selectedOptions.map((opt: any) => opt.value) : [];

    // Filter out any values that aren't visible for current role
    const visibleTabs = this.getVisibleTabsForCurrentRole();
    const visibleTabIds = visibleTabs.map(tab => tab.id);
    const validSelectedValues = selectedValues.filter(id => visibleTabIds.includes(id));

    // Save to user-specific session storage
    this.saveSelectedTabsToStorage(validSelectedValues);

    // Update state
    this.setState({ selectedTabs: validSelectedValues }, () => {
      // Load data for newly selected tabs
      this.loadVisibleTabsData();
    });
  };

  // Custom option renderer for Select All
  getTabOptionsWithSelectAll = () => {
    // Get only tabs visible for current user
    const visibleTabs = this.getVisibleTabsForCurrentRole();

    const allTabOptions = visibleTabs.map(tab => ({
      value: tab.id,
      label: tab.label
    }));

    // Add Select All option at the beginning
    return [
      {
        label: 'Select All',
        options: [
          { value: 'select-all', label: '✅ Select All Reports' },
          ...allTabOptions
        ]
      }
    ];
  };

  // Custom filter option to handle Select All
  handleSelectAllChange = (selectedOptions: any) => {
    if (!selectedOptions) {
      this.handleTabSelectionChange([]);
      return;
    }

    // Check if Select All is in the selected options
    const hasSelectAll = selectedOptions.some((opt: any) => opt.value === 'select-all');

    if (hasSelectAll) {
      // If Select All is selected, select all actual tabs (only visible ones)
      const visibleTabs = this.getVisibleTabsForCurrentRole();
      const allTabValues = visibleTabs.map(tab => ({ value: tab.id, label: tab.label }));
      this.handleTabSelectionChange(allTabValues);
    } else {
      // Otherwise, just use the selected options (filter out any Select All that might be there)
      const filteredOptions = selectedOptions.filter((opt: any) => opt.value !== 'select-all');
      this.handleTabSelectionChange(filteredOptions);
    }
  };

  // Custom value formatter to display selected count
  getDisplayValue = (selectedOptions: any) => {
    if (!selectedOptions || selectedOptions.length === 0) {
      return "Select reports...";
    }

    // Filter out Select All from count
    const actualSelections = selectedOptions.filter((opt: any) => opt.value !== 'select-all');

    if (actualSelections.length === this.getVisibleTabsForCurrentRole().length) {
      return "All Reports Selected";
    }

    return `${actualSelections.length} report(s) selected`;
  };

  getPageDynamicData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };
    callApi("POST", "authenticating_pages_list_new.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ pageDynamic: result?.responseJson?.data }, () => {
          const hasWorkingNonWorking = this.state.pageDynamic?.some(
            (page: any) =>
              page?.page_name === "Working & Non Working" && page?.status,
          );
          this.setState({ showWorkingNonWorkingSection: hasWorkingNonWorking });
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getteamdetailsTableData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    let obj = {
      id: userDetails ? userDetails.userId : null,
    };
    return callApi("POST", "team_type.php", obj)
      .then((res) => res.data)
      .then((result) => {
        this.setState({ teamDetailsData: result.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getTimeDifference(time1) {
    const time2 = new Date().toISOString();
    const date1: any = new Date(time1);
    let date2;

    if (Date.parse(time2)) {
      date2 = new Date(time2);
    } else {
      throw new Error("Invalid date string for time2");
    }
    let timeDiff = Math.abs(date2 - date1);
    let hours = Math.floor(timeDiff / (1000 * 60 * 60));
    timeDiff -= hours * 1000 * 60 * 60;
    let minutes = Math.floor(timeDiff / (1000 * 60));
    timeDiff -= minutes * 1000 * 60;
    let seconds = Math.floor(timeDiff / 1000);
    const formattedHours = String(hours).padStart(2, "0");
    const formattedMinutes = String(minutes).padStart(2, "0");
    const formattedSeconds = String(seconds).padStart(2, "0");
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }

  refreshTracking = () => {
    this.setState({ isLoading: true });
    this.getTeamTrackingTableData();
    this.getFileTeamTrackingTableData();
  };

  getTeamTrackingTableData = () => {
    return callApi("GET", "team_tracking.php")
      .then((res) => res.data)
      .then((result) => {
        if (result.result == true) {
          const teamTrackingData: {
            [key: string]: {
              id: string;
              name: string;
              email: string;
              teamType: string;
              file: string;
              taken_dt: string | null;
            }[];
          } = result.data;
          this.setState({ teamTrakingData: teamTrackingData }, async () => {
            let getAttendance = await this.getAttendance();
            if (getAttendance) {
              const updatedTeamTrackingData: {
                [key: string]: {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  file: string;
                  taken_dt: string | null;
                  present: boolean;
                }[];
              } = {};
              for (const [team, members] of Object.entries(
                this.state.teamTrakingData,
              )) {
                const typedMembers: {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  file: string;
                  taken_dt: string | null;
                }[] = members as {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  file: string;
                  taken_dt: string | null;
                }[];
                updatedTeamTrackingData[team] = typedMembers.map((member) => {
                  const workTimeDifference = this.getTimeDifference(
                    member.taken_dt,
                  );
                  const present = this.isPresent(member.email);
                  return { ...member, present, diffTime: workTimeDifference };
                });
              }
              this.setState(
                {
                  teamTrakingData: updatedTeamTrackingData,
                  showTeamTracking: true,
                  isLoading: false,
                },
                () => { },
              );
            }
          });
        } else {
          this.setState({ teamTrakingData: [], showTeamTracking: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getFileTeamTrackingTableData = () => {
    this.setState({ isLoading: true });
    return callApi("GET", "file_team_tracking.php")
      .then((res) => res.data)
      .then((result) => {
        if (result.result == true) {
          const teamTrackingData: {
            [key: string]: {
              id: string;
              name: string;
              email: string;
              teamType: string;
              taken_filegrade: string | null;
              user_grade: string;
              total_lod: number;
              pending_lod: number;
              not_related_lod: number;
              file: string;
              taken_dt: string | null;
            }[];
          } = result.data;
          this.setState({ fileTeamTrakingData: teamTrackingData }, async () => {
            let getAttendance = await this.getAttendance();
            if (getAttendance) {
              const updatedTeamTrackingData: {
                [key: string]: {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  taken_filegrade: string | null;
                  user_grade: string;
                  total_lod: number;
                  pending_lod: number;
                  not_related_lod: number;
                  file: string;
                  taken_dt: string | null;
                  present: boolean;
                  diffTime: string;
                }[];
              } = {};
              for (const [team, members] of Object.entries(
                this.state.fileTeamTrakingData,
              )) {
                const typedMembers: {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  taken_filegrade: string | null;
                  overall_ideal_time: any;
                  user_grade: string;
                  total_lod: number;
                  pending_lod: number;
                  not_related_lod: number;
                  file: string;
                  taken_dt: string | null;
                }[] = members as {
                  id: string;
                  name: string;
                  email: string;
                  teamType: string;
                  taken_filegrade: string | null;
                  overall_ideal_time: any;
                  user_grade: string;
                  total_lod: number;
                  pending_lod: number;
                  not_related_lod: number;
                  file: string;
                  taken_dt: string | null;
                }[];
                updatedTeamTrackingData[team] = typedMembers.map((member) => {
                  const workTimeDifference = this.getTimeDifference(
                    member.taken_dt,
                  );
                  const present = this.isPresent(member.email);
                  return { ...member, present, diffTime: workTimeDifference };
                });
              }
              this.setState(
                {
                  fileTeamTrakingData: updatedTeamTrackingData,
                  showTeamTracking: true,
                  isLoading: false,
                },
                () => { },
              );
            }
          });
        } else {
          this.setState({ fileTeamTrakingData: [], showTeamTracking: false });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  isPresent = (email) => {
    const lowerCaseEmail = email.toLowerCase();
    return this.state.presentUsers.some(
      (member: any) => member.Email_Id.toLowerCase() === lowerCaseEmail,
    );
  };

  getAttendance = async () => {
    const date = new Date();
    const currentDate = moment(date).format("YYYY-MM-DD");

    const obj = { date: currentDate };
    const presentUsers: any = [];
    try {
      const response = await axios.post(
        "https://traning.lawhands.org/law_hands/public/phpapi/getattendance.php",
        obj,
      );
      const data = response.data.responseJson.data;
      if (response.status === 200) {
        data.forEach((element: any) => {
          if (element.isEmailVerified === "Approved" && element.start_time) {
            presentUsers.push(element);
          }
        });
        this.setState({ presentUsers }, () => { });
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.error("Error:", error);
      return false;
    }
  };

  goToFileDashboard = (id) => {
    if (id) {
      const url = `/inprogress-file`;
      localStorage.setItem("url", url);
      let obj = { file_id: id };
      localStorage.setItem("thisPopup", JSON.stringify(obj));
      localStorage.setItem("currentfileId", JSON.stringify(id));
      this.props.history.push("/file-dashboard/" + id);
    }
  };

  previousPop = () => {
    $("#out_reason").modal("show");
    $("#another-reason").modal("hide");
  };

  BacktoFile = () => {
    $("#out_reason").modal("hide");
    const fileid1: any = localStorage.getItem("currentfileId");
    this.props.history.push("/file-dashboard/" + JSON.parse(fileid1));
  };

  getOutTime = () => {
    let date = new Date();
    let stratTime = date.getTime();
    localStorage.setItem("startTime", JSON.stringify(stratTime));
    let outDate = date.toLocaleDateString();
    localStorage.setItem("OutDateGet", JSON.stringify(outDate));
    var Railway = date.getMinutes();
    if (Railway < 10) {
      var TotalMinutes = "0" + Railway;
      let ouTtime = date.getHours() + ":" + TotalMinutes;
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    } else {
      let ouTtime: any = date.getHours() + ":" + date.getMinutes();
      localStorage.setItem("outtimeGet", JSON.stringify(ouTtime));
    }
  };

  ouTime = () => {
    const getfileId: any = localStorage.getItem("currentfileId");

    if (localStorage.getItem("currentfileId")) {
      $("#out_reason").modal("show");
    }
  };

  outimeGet = () => {
    this.setState({ isLoading: true });
    const fileid1: any = localStorage.getItem("currentfileId");
    const userid1: any = localStorage.getItem("user1");
    const inreason: any = localStorage.getItem("in_reason");
    const intime: any = localStorage.getItem("IntimeGet");
    const outtime: any = localStorage.getItem("outtimeGet");
    const outdate: any = localStorage.getItem("OutDateGet");
    const secondsSpent = moment(outtime, "HH:mm").diff(
      moment(intime, "HH:mm"),
      "seconds",
    );
    const insertId: any = localStorage.getItem("ProcessEodInsertID");
    let updatedRemainingTime: any = localStorage.getItem(
      "updatedRemainingTime",
    );
    let updatedtime = Math.round(updatedRemainingTime);
    if (this.state.outreason == "") {
      this.setState({ selectVal: true });
    } else {
      let obj = {
        file_id: JSON.parse(fileid1),
        user_id: JSON.parse(userid1),
        in_reason: JSON.parse(inreason),
        out_reason: this.state.outreason,
        intime: JSON.parse(intime),
        outtime: JSON.parse(outtime),
        insert_date: JSON.parse(outdate),
        total_seconds: secondsSpent,
        balance_min: updatedtime,
        insert_id: insertId,
      };

      callApi("POST", "process_eod_insert.php", obj)
        .then((res) => res.data)
        .then((response) => {
          this.setState({ isLoading: false });
          localStorage.removeItem("updatedRemainingTime");
          localStorage.removeItem("in_reason");
          localStorage.removeItem("outreason");
          localStorage.removeItem("IntimeGet");
          localStorage.removeItem("OutDateGet");
          $("#out_reason").modal("hide");
          $("#another-reason").modal("hide");
          ToastsStore.success("Your Reason Saved Successfully");
          let process_officerId: any =
            localStorage.getItem("process_office_id");
          let process_officer_id = JSON.parse(process_officerId);
          const userid1: any = localStorage.getItem("user1");
          let user_id = JSON.parse(userid1);
          let file_id = JSON.parse(fileid1);
          const take_file: any = localStorage.getItem("takenfile_id");
          const user: any = localStorage.getItem("user");
          const query_status: any = localStorage.getItem("query_raised_status");
          const file_completed = localStorage.getItem("file_completed_status");
          if (
            process_officer_id == user_id &&
            take_file != "" &&
            take_file === fileid1 &&
            query_status == "false" &&
            file_completed == "false"
          ) {
            this.timeUpdate(file_id);
          } else {
            localStorage.removeItem("currentfileId");
            localStorage.removeItem("query_raised_status");
            localStorage.removeItem("file_completed_status");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          ToastsStore.error("Your Reason Not Stored");
        });
    }
  };

  timeUpdate = (file_id) => {
    const loginuser: any = localStorage.getItem("user1");
    let req = {
      id: file_id,
      reason: "File Out",
      created_by: JSON.parse(loginuser),
    };
    callApi("POST", "time_update.php", req)
      .then((res) => res.data)
      .then((response) => {
        localStorage.removeItem("currentfileId");
        localStorage.removeItem("query_raised_status");
        localStorage.removeItem("file_completed_status");
      });
  };

  onchangeReason = (e: any) => {
    if (e.target.value == "Other") {
      this.setState({ in_reason: "", selectVal: false });
      $("#out_reason").modal("hide");
      $("#another-reason").modal("show");
    } else if (e.target.value == "select") {
      this.setState({ setResponse: false });
    } else {
      this.setState({ [e.target.name]: e.target.value, selectVal: false });
    }
  };

  onchange = (e: any) => {
    this.setState({
      [e.target.name]: e.target.value.replace(/\s+/g, " ").trim(),
      selectVal: false,
    });
  };

  getBanks() {
    callApi("GET", "bank_get.php")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ banks: result.data });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  goToFileDashboardbytrack = (id) => {
    const url = "/dashboard";
    localStorage.setItem("url", url);
    this.props.history.push("/file-dashboard/" + id);
  };

  getLawHandsBranches() {
    callApi("GET", "get_branch.php")
      .then((res) => res.data)
      .then((response) => {
        const user: any = localStorage.getItem("user");
        const userDetails = user ? JSON.parse(user) : "";
        let lawhandsBranches = response.data;
        if (
          lawhandsBranches &&
          lawhandsBranches.length > 0 &&
          userDetails.role_id !== "1" &&
          userDetails.my_branchs
        ) {
          const myBranchList = userDetails.my_branchs.split(",");
          lawhandsBranches = lawhandsBranches.filter((value) =>
            myBranchList.includes(value.id),
          );
        }
        this.setState({ lawhandsBranches });
      })
      .catch((err) => {
        console.log({ err });
      });
  }

  getBankBranches() {
    callApi("GET", "bank_branch_get.php")
      .then((res) => res.data)
      .then((result) => {
        this.setState({ branches: result.data, filteredBranches: [] });
        if (this.state.bank_private_name) {
          this.filterBranches(this.state.bank_private_name);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  listBankproduct = () => {
    this.setState({ isFileRefresh: false });
    callApi("GET", "bank_product_get.php")
      .then((res) => res.data)
      .then((response) => {
        const files = response.data;
        this.setState({ products: files });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  filterProduct = (bankid: any) => {
    if (bankid && bankid !== "all") {
      const filteredProduct = this.state.products.filter(
        (branch: any) => branch.bank_id === bankid,
      );
      const state = this.state;
      state.filteredProduct = filteredProduct;
      this.setState({ ...state });
    } else {
      this.setState({ filteredProduct: this.state.products, product_id: "", branch: "", filteredBranches: [] });
    }
  };

  filterBranches = (bankid) => {
    const filteredBranches = bankid && bankid !== "all"
      ? this.state.branches.filter((branch: any) => branch.bank_id === bankid)
      : this.state.branches;
    const state = this.state;
    state.filteredBranchesproduct = filteredBranches;
    this.setState({ ...state });
  };

  filterBranchesproduct = (productid) => {
    const state = { ...this.state };
    const userBranches = state.lawHandsBranch.split(",");

    const filteredBranches = state.filteredBranchesproduct.filter(
      (branch: any) => {
        const branchLawhandsArray = branch.lawhands_branch.split(",");
        const hasMatchingBranch = branchLawhandsArray.some((b) =>
          userBranches.includes(b),
        );

        const productMatches = productid && productid !== "all" ? branch.product_id === productid : true;
        const bankMatches = state.bank_private_name && state.bank_private_name !== "all"
          ? branch.bank_id === state.bank_private_name
          : true;

        return productMatches && bankMatches && hasMatchingBranch;
      },
    );

    state.filteredBranches = filteredBranches;
    state.branch = "";

    this.setState(state);
  };

  getEodTableData = (type: any) => {
    const {
      eodFromDate,
      eodToDate,
      lawHandsBranch,
      bank_private_name,
      product_id,
      branch,
    } = this.state;

    let obj: any = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
    };

    localStorage.setItem("report_filter", JSON.stringify(obj));

    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    obj = {
      ...obj,
      roleId: userDetails ? userDetails.role_id : null,
      userId: userDetails ? userDetails.userId : null,
      roleType: userDetails ? userDetails.roleType : null,
    };

    // Set isDateSearchClicked based on whether both dates are provided
    const isSearchClicked = !!(eodFromDate && eodToDate);

    // Reset data and loaded tabs when searching new date range
    this.setState({
      eodData: [],
      queryMailData: [],
      queryValidationData: [],
      vettingData: [],
      deviationData: [],
      deviationTakeData: [],
      rectificationData: [],
      branchEodData: [],
      teamDetailsData: [],
      teamTrakingData: {},
      fileTeamTrakingData: {},
      loadedTabs: new Set(),
      isDateSearchClicked: isSearchClicked, // Set this here
      isSearchLoading: true,
    }, async () => {
      // Load data for visible tabs with new filters
      try {
        await this.loadVisibleTabsData();
      } finally {
        this.setState({ isSearchLoading: false });
      }
    });
  };

  getBranchEodData = () => {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    return callApi("POST", "main_report_branch.php", {
      branch: userDetails.my_branchs,
      role_id: userDetails.role_id,
    })
      .then((res) => res.data)
      .then((result) => {
        this.setState({ branchEodData: result.data });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  handleChange1 = async (e: any, propName?, fieldType?) => {
    let fieldName: any = "";
    let fieldValue: any = "";

    if (fieldType === "multiselect" && propName === "lawHandsBranch") {
      fieldName = propName;
      const selectedOptions = Array.isArray(e) ? e : [];
      const allBranchIds = this.getAllLawHandsBranchIds();
      const selectedValues = selectedOptions.map((item: any) => String(item.value));
      const isAllSelected = selectedValues.includes("all");
      fieldValue = isAllSelected
        ? allBranchIds.join(",")
        : selectedValues.filter((val: string) => val !== "all").join(",");
      this.setState({ isAllLawHandsBranchSelected: isAllSelected });
    } else if (fieldType === "singleselect") {
      fieldName = propName;
      fieldValue = e ? e.value : "";
    } else if (e && e.target) {
      fieldName = e.target.name;
      fieldValue = e.target.value;
    } else {
      return;
    }

    if (fieldName === "bank_private_name") {
      await this.filterProduct(fieldValue);
      await this.filterBranches(fieldValue);
      this.setState({ product_id: "", branch: "", filteredBranches: [] });
    }

    if (fieldName === "product_id") {
      const newProductId = fieldValue;
      const state = this.state;
      state.product_id = newProductId;
      this.filterBranchesproduct(fieldValue);
      return;
    }

    this.setState({ [fieldName]: fieldValue });
  };

  handleChange = (e, stateName?, type?) => {
    if (e.target.name === "eodToDate") {
      this.setState({ todate: e.target.value });
    }
    if (e.target.name === "eodfromDate") {
      this.setState({
        fromdate: e.target.value,
      });
    }
    if (stateName && type === "dropdown") {
      this.setState({
        [stateName]: e.value,
      });
    } else this.setState({ [e.target.name]: e.target.value });
  };

  routeSubReport = (detail, type) => {
    const {
      eodFromDate,
      eodToDate,
      lawHandsBranch,
      bank_private_name,
      product_id,
      branch,
    } = this.state;
    const obj = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
      isRaised: false,
    };
    if (detail.details === "Raised Query") {
      obj.isRaised = true;
    }
    this.props.history.push(`/sub-report/${type}/${detail.status}`, {
      filterData: { ...obj },
    });
  };

  routeQueryValidationReport = (detail: any, type: string) => {
    const {
      eodFromDate,
      eodToDate,
      lawHandsBranch,
      bank_private_name,
      product_id,
      branch,
    } = this.state;
    const obj = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
    };
    this.props.history.push(
      `/query-validation-report/${type}/${detail.status}`,
      {
        filterData: { ...obj },
      },
    );
  };

  routeQueryMailReport = (detail: any, type: string) => {
    const {
      eodFromDate,
      eodToDate,
      lawHandsBranch,
      bank_private_name,
      product_id,
      branch,
    } = this.state;
    const obj = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
    };
    this.props.history.push(
      `/query-mail-report/${type}/${detail.status}`,
      {
        filterData: { ...obj },
      },
    );
  };

  routeReport = (detail, type, path) => {
    const {
      eodFromDate,
      eodToDate,
      lawHandsBranch,
      bank_private_name,
      product_id,
      branch,
    } = this.state;
    const obj = {
      branch: this.getBranchPayloadValue(),
      fromdate: eodFromDate,
      todate: eodToDate,
      bankname: this.normalizeFilterPayloadValue(bank_private_name),
      product_id: this.normalizeFilterPayloadValue(product_id),
      bankbranch: this.normalizeFilterPayloadValue(branch),
      isRaised: false,
    };
    if (path == "devitaion") {
      this.props.history.push(`/deviation-report/${type}/${detail.status}`, {
        filterData: { ...obj },
      });
    } else if (path == "rectify") {
      this.props.history.push(
        `/rectification-report/${type}/${detail.status}`,
        {
          filterData: { ...obj },
        },
      );
    } else if (path == "vetting") {
      this.props.history.push(`/vetting-report/${type}/${detail.status}`, {
        filterData: { ...obj },
      });
    } else if (path == "devitaionTake") {
      this.props.history.push(
        `/deviation-take-report/${type}/${detail.status}`,
        {
          filterData: { ...obj },
        },
      );
    }
  };

  handleDateChange = (date, dateStr, type) => {
    const isDateCleared = !dateStr;

    const resetBtdCount = (rows: any[] = []) =>
      rows.map((row: any) => ("btd" in row ? { ...row, btd: 0 } : row));

    this.setState((prevState: any) => ({
      [type]: dateStr,
      // Prevent stale BTD/date-range results from showing before user clicks Search again
      isDateSearchClicked: false,
      eodData: resetBtdCount(prevState.eodData),
      queryMailData: resetBtdCount(prevState.queryMailData),
      queryValidationData: resetBtdCount(prevState.queryValidationData),
      vettingData: resetBtdCount(prevState.vettingData),
      deviationData: resetBtdCount(prevState.deviationData),
      deviationTakeData: resetBtdCount(prevState.deviationTakeData),
      rectificationData: resetBtdCount(prevState.rectificationData),
      loadedTabs: new Set(),
    }), () => {
      // If a date is cleared, reload currently selected report APIs
      if (isDateCleared) {
        this.loadVisibleTabsData();
      }
    });
  };

  lawBranchName = (type: any) => {
    if (type == 2) {
      this.setState({ lhBranchShow: true });
      this.getLawHandsBranches();
    }
  };

  bankName = (type: any) => {
    if (type == 2) {
      this.setState({ showBank: true });
      this.setState({ productName: true });
      this.setState({ bankBranch: true });
      this.getBanks();
      this.listBankproduct();
      this.getBankBranches();
    }
  };

  disabledDate = (current) => {
    return (
      current &&
      (current > moment().endOf("day") ||
        current < moment().subtract(7, "months").startOf("day"))
    );
  };

  // Render EOD Table
  renderEODTable = () => {
    const { eodData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1">Login Report</h5>
          </div>
          <div className="card-body">
            {eodData && eodData.length > 0 ? (
              <>
                <ReactHTMLTableToExcel
                  id="test-table-xls-button"
                  className="download-table-xls-button excel-download-btn mt-1 mb-1"
                  table="logineodtable"
                  filename="Login-report"
                  sheet="tablexls"
                  buttonText="Download as Excel"
                />
              </>
            ) : (
              ""
            )}

            <div className="dt-responsive table-responsive">
              <table
                id="logineodtable"
                className="table table-striped table-bordered nowrap"
              >
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {eodData && eodData.length > 0 ? (
                    eodData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeSubReport(listValue, "ftd")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeSubReport(listValue, "mtd")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeSubReport(listValue, "ytd")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeSubReport(listValue, "btd")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Query Validation Table
  renderQueryValidationTable = () => {
    const { queryValidationData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Query Validation</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {queryValidationData && queryValidationData.length > 0 ? (
                    queryValidationData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeQueryValidationReport(listValue, "ftd")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeQueryValidationReport(listValue, "mtd")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeQueryValidationReport(listValue, "ytd")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeQueryValidationReport(listValue, "btd")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Query Mail Table
  renderQueryMailTable = () => {
    const { queryMailData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Received Query Via Mail</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {queryMailData && queryMailData.length > 0 ? (
                    queryMailData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeQueryMailReport(listValue, "ftd")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeQueryMailReport(listValue, "mtd")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeQueryMailReport(listValue, "ytd")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeQueryMailReport(listValue, "btd")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Vetting Table
  renderVettingTable = () => {
    const { vettingData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Vetting Report</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {vettingData && vettingData.length > 0 ? (
                    vettingData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ftd", "vetting")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "mtd", "vetting")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ytd", "vetting")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeReport(listValue, "btd", "vetting")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Deviation Tracker Table
  renderDeviationTrackerTable = () => {
    const { deviationTakeData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Deviation Tracker</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {deviationTakeData && deviationTakeData.length > 0 ? (
                    deviationTakeData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ftd", "devitaionTake")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "mtd", "devitaionTake")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ytd", "devitaionTake")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeReport(listValue, "btd", "devitaionTake")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Rectification Table
  renderRectificationTable = () => {
    const { rectificationData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Rectification Report</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {rectificationData && rectificationData.length > 0 ? (
                    rectificationData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ftd", "rectify")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "mtd", "rectify")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ytd", "rectify")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeReport(listValue, "btd", "rectify")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Deviation Report Table
  renderDeviationTable = () => {
    const { deviationData, isDateSearchClicked, eodFromDate, eodToDate } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Deviation Report</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                    {isDateSearchClicked && eodFromDate && eodToDate && (
                      <th>{eodFromDate + " - " + eodToDate}</th>
                    )}
                  </tr>
                </thead>
                <tbody className="text-center">
                  {deviationData && deviationData.length > 0 ? (
                    deviationData.map((listValue: any, listIndex: number) => (
                      <tr
                        key={listIndex + listValue.details}
                        style={{ cursor: "pointer" }}
                      >
                        <td
                          style={{
                            padding: "0.60rem",
                            borderColor: "inherit",
                            fontWeight: "bold",
                            background: listValue.color,
                          }}
                        >
                          {listValue.details}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ftd", "devitaion")}>
                          {listValue.ftd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "mtd", "devitaion")}>
                          {listValue.mtd}
                        </td>
                        <td onClick={() => this.routeReport(listValue, "ytd", "devitaion")}>
                          {listValue.ytd}
                        </td>
                        {isDateSearchClicked && eodFromDate && eodToDate && listValue.btd && (
                          <td onClick={() => this.routeReport(listValue, "btd", "devitaion")}>
                            {listValue.btd}
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={5}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render My Team Table
  renderMyTeamTable = () => {
    const { teamDetailsData } = this.state;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">My Team Workfile</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Name</th>
                    <th>File No</th>
                    <th>Property Owner Name</th>
                    <th>Time</th>
                  </tr>
                </thead>
                <tbody>
                  {teamDetailsData && teamDetailsData.length > 0 ? (
                    teamDetailsData.map((list: any, i: number) => (
                      <tr className="text-center" key={i}>
                        <td>{list.name}</td>
                        <td onClick={() => this.goToFileDashboard(list.file)}>
                          {list.file}
                        </td>
                        <td>{list.property_ownername}</td>
                        <td>{list.updated_dt}</td>
                      </tr>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey", textAlign: "center" }}>
                      <td colSpan={4}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Branch Login Table
  renderBranchLoginTable = () => {
    const { branchEodData } = this.state;
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    const isAdmin = (userDetails.role_id === "1" || userDetails.role_id === "2") && userDetails.roleType != "5";

    if (!isAdmin) return null;

    return (
      <div className="col-sm-12">
        <div className="card">
          <div className="card-header">
            <h5 className="mt-1 mb-1">Branch wise Login Report</h5>
          </div>
          <div className="card-body">
            <div className="dt-responsive table-responsive">
              <table  id="eodtable" className="table table-striped table-bordered nowrap">
                <thead className="text-center">
                  <tr style={{ padding: "0.50rem" }}>
                    <th>Details</th>
                    <th>FTD (For the Day)</th>
                    <th>MTD (Month to Date)</th>
                    <th>YTD (Year to Date)</th>
                  </tr>
                </thead>
                <tbody>
                  {branchEodData && branchEodData.length > 0 ? (
                    branchEodData.map((list: any, i: number) => (
                      <React.Fragment key={i}>
                        <tr className="group" style={{ cursor: "pointer" }}>
                          <td
                            colSpan={4}
                            style={{
                              padding: "0.60rem",
                              fontWeight: "bold",
                              background: list.color,
                              display: list.display,
                            }}
                          >
                            {list.details}
                          </td>
                        </tr>
                        {Object.keys(list.btd).map((key: string, idx: number) => (
                          <tr className="text-center" key={`${i}-${idx}`}>
                            <td>{key}</td>
                            <td>{list.ftd[key]}</td>
                            <td>{list.mtd[key]}</td>
                            <td>{list.ytd[key]}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    ))
                  ) : (
                    <tr style={{ width: "100%", background: "grey" }}>
                      <td colSpan={4}>No Details Found</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Render Team Tracking Section
  renderTeamTracking = () => {
    const { teamTrakingData, searchQuery, isLoading, showWorkingNonWorkingSection, showTeamTracking } = this.state;
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";

    if (!showTeamTracking || !showWorkingNonWorkingSection || Object.keys(teamTrakingData).length === 0) {
      return null;
    }

    return (
      <>
        <div className="col-md-5">
          <h5 className="mt-1 mb-3" style={{ fontSize: "16px" }}>Team Wise Tracking</h5>
          <input
            className="team-filter-input"
            type="text"
            placeholder="Search by name..."
            value={searchQuery}
            onChange={(e) => this.setState({ searchQuery: e.target.value })}
          />
        </div>
        <div className="col-md-6 icon-detail">
          <div className="col-auto text-right update-meta">
            <i className="feather icon-user-minus f-w-600 bg-c-yellow update-icon icon-yellow"></i>
          </div>
          <span>- Absent</span>
          <div className="col-auto text-right update-meta">
            <i className="feather icon-x f-w-600 bg-c-red update-icon icon-red"></i>
          </div>
          <span>- Present File not Working</span>
          <div className="col-auto text-right update-meta">
            <i className="feather icon-check f-w-600 bg-c-green update-icon icon-green"></i>
          </div>
          <span>- Present File Working</span>
        </div>
        <div className="col-md-1">
          <button className="refresh-btn" onClick={() => this.refreshTracking()}>
            {isLoading ? (
              <i className="fa fa-spinner fa-spin"></i>
            ) : (
              <MdOutlineRefresh style={{ height: "30", width: "20px" }} />
            )}
          </button>
        </div>
        {Object.keys(teamTrakingData).map((teamType, index) => {
          if (role_id === "1" || role_id === "2") {
            const items = teamTrakingData[teamType];
            const absentItems = items.filter((detail) => detail.present === false);
            const fileNullItems = items.filter((detail) => detail.present === true && detail.file == null);
            const fileNotNullItems = items.filter((detail) => detail.present === true && detail.file != null);

            const sortedAbsentItems = absentItems
              .filter((detail) => detail.name.toLowerCase().includes(searchQuery.toLowerCase()))
              .sort((a, b) => a.name.localeCompare(b.name));

            const sortedFileNullItems = fileNullItems
              .filter((detail) => detail.name.toLowerCase().includes(searchQuery.toLowerCase()))
              .sort((a, b) => a.name.localeCompare(b.name));

            const sortedFileNotNullItems = fileNotNullItems
              .filter((detail) => detail.name.toLowerCase().includes(searchQuery.toLowerCase()))
              .sort((a, b) => a.name.localeCompare(b.name));

            return (
              <div className="col-md-3" key={index}>
                <div className="card latest-update-card update-card">
                  <div className="card-header">
                    <h5>{teamType}</h5>
                  </div>
                  <div
                    className="new-scroll ps--active-y"
                    style={{ height: "850px", position: "relative", overflowY: "scroll" }}
                  >
                    <div className="card-body">
                      <div className="latest-update-box">
                        {sortedAbsentItems.map((detail, detailIndex) => (
                          <div className="row p-t-20 p-b-10" key={detailIndex}>
                            <div className="col-auto text-right update-meta">
                              <i className="feather icon-user-minus f-w-600 bg-c-yellow update-icon"></i>
                            </div>
                            <div className="col p-l-5">
                              <h6 className="m-0">
                                {detail.name} <br />
                                <span
                                  style={{
                                    color: detail.in_shift == 1 ? "green" : "red",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {detail.shift_active_status}
                                </span>
                              </h6>
                              {detail.file ? (
                                <>
                                  <span style={{ fontWeight: "bold" }}>{`${detail.file} - `}</span>
                                  <span style={{ fontWeight: "bold", color: "green" }}>
                                    {detail.diffTime}
                                  </span>
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                        ))}
                        {sortedFileNullItems.map((detail, detailIndex) => (
                          <div className="row p-t-20 p-b-10" key={detailIndex}>
                            <div className="col-auto text-right update-meta">
                              <i className="feather icon-x f-w-600 bg-c-red update-icon"></i>
                            </div>
                            <div className="col p-l-5">
                              <h6 className="m-0">
                                {detail.name} <br />
                                <span
                                  style={{
                                    color: detail.in_shift == 1 ? "green" : "red",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {detail.shift_active_status}
                                </span>
                              </h6>
                              {detail.file ? (
                                <>
                                  <span>{`${detail.file} - `}</span>
                                  <span style={{ fontWeight: "bold", color: "green" }}>
                                    {detail.diffTime}
                                  </span>
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                        ))}
                        {sortedFileNotNullItems.map((detail, detailIndex) => (
                          <div className="row p-t-20 p-b-10" key={detailIndex}>
                            <div className="col-auto text-right update-meta">
                              <i className="feather icon-check f-w-600 bg-c-green update-icon"></i>
                            </div>
                            <div className="col p-l-5">
                              <h6 className="m-0">
                                {detail.name} <br />
                                <span
                                  style={{
                                    color: detail.in_shift == 1 ? "green" : "red",
                                    fontWeight: "bold",
                                  }}
                                >
                                  {detail.shift_active_status}
                                </span>
                              </h6>
                              {detail.file ? (
                                <>
                                  <span>{`${detail.file} - `}</span>
                                  <span style={{ fontWeight: "bold", color: "green" }}>
                                    {detail.diffTime}
                                  </span>
                                </>
                              ) : (
                                "-"
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })}
      </>
    );
  };

  // Add this method to toggle user expansion
  toggleUserExpand = (userId, event) => {
    event.stopPropagation();

    const { expandedUserId } = this.state;

    if (expandedUserId === userId) {
      // Collapse if already expanded
      this.setState({ expandedUserId: null, queueData: { data: [], Completed_file_count: 0 } });
    } else {
      // Expand and fetch data for new user
      this.setState({
        expandedUserId: userId,
        queueLoading: true,
        queueData: { data: [], Completed_file_count: 0 }
      }, () => {
        this.fetchUserQueue(userId);
      });
    }
  };

  // Render File Grade Tracking
  renderFileGradeTracking = () => {
    const {
      fileTeamTrakingData,
      searchQuery,
      isLoading,
      showWorkingNonWorkingSection,
      expandedUserId,
      queueData,
      queueLoading
    }: any = this.state;
    const user: any = localStorage.getItem("user");
    const role_id = user ? JSON.parse(user)["role_id"] : "";

    if (!showWorkingNonWorkingSection || Object.keys(fileTeamTrakingData || {}).length === 0) {
      return null;
    }

    return (
      <>
        <div
          className="col-md-12"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "15px",
            flexWrap: "nowrap",
            gap: "10px",
          }}
        >
          <div style={{ minWidth: "200px", flex: "0 0 auto" }}>
            <h5 className="mt-1 mb-3" style={{ fontSize: "16px" }}>Process Wise Tracking</h5>
            <input
              className="team-filter-input"
              type="text"
              placeholder="Search by name or file no..."
              value={searchQuery}
              onChange={(e) => this.setState({ searchQuery: e.target.value })}
              style={{ width: "100%" }}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "15px",
              flex: "1 1 auto",
              justifyContent: "center",
            }}
          >
            <span style={{ fontWeight: "bold", whiteSpace: "nowrap" }}>LOD Types:</span>
            <div style={{ display: "flex", alignItems: "center", gap: "5px", whiteSpace: "nowrap" }}>
              <div style={{ width: "16px", height: "16px", backgroundColor: "#d1d1d1", borderRadius: "4px" }}></div>
              <span style={{ fontSize: "12px" }}>Not Related</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px", whiteSpace: "nowrap" }}>
              <div style={{ width: "16px", height: "16px", backgroundColor: "#c4fec6", borderRadius: "4px" }}></div>
              <span style={{ fontSize: "12px" }}>Total</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "5px", whiteSpace: "nowrap" }}>
              <div style={{ width: "16px", height: "16px", backgroundColor: "#ffadad", borderRadius: "4px" }}></div>
              <span style={{ fontSize: "12px" }}>Pending</span>
            </div>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "12px",
              flex: "1 1 auto",
              justifyContent: "flex-end",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "3px", whiteSpace: "nowrap" }}>
              <i
                className="feather icon-x f-w-600 bg-c-red update-icon"
                style={{
                  fontSize: "12px",
                  width: "18px",
                  height: "18px",
                  lineHeight: "18px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              ></i>
              <span style={{ fontSize: "11px" }}>Not Working</span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "3px", whiteSpace: "nowrap" }}>
              <i
                className="feather icon-check f-w-600 bg-c-green update-icon"
                style={{
                  fontSize: "12px",
                  width: "18px",
                  height: "18px",
                  lineHeight: "18px",
                  display: "inline-block",
                  textAlign: "center",
                }}
              ></i>
              <span style={{ fontSize: "11px" }}>Working</span>
            </div>
          </div>

          <div style={{ flex: "0 0 auto" }}>
            <button className="refresh-btn" onClick={() => this.refreshTracking()} style={{ padding: "4px 8px" }}>
              {isLoading ? (
                <i className="fa fa-spinner fa-spin"></i>
              ) : (
                <MdOutlineRefresh style={{ height: "20px", width: "20px" }} />
              )}
            </button>
          </div>
        </div>

        {Object.keys(fileTeamTrakingData || {}).map((teamType, index) => {
          if (role_id === "1" || role_id === "2") {
            const items = fileTeamTrakingData[teamType] || [];

            const parseTimeToSeconds = (timeStr) => {
              if (!timeStr || timeStr === "-" || timeStr === null || timeStr === undefined) return -1;
              const timeStrClean = timeStr.toString().trim();
              const parts = timeStrClean.split(":");
              if (parts.length < 2) return -1;
              const hours = parseInt(parts[0], 10) || 0;
              const minutes = parseInt(parts[1], 10) || 0;
              const seconds = parts.length > 2 ? parseInt(parts[2], 10) || 0 : 0;
              return hours * 3600 + minutes * 60 + seconds;
            };

            const sortByDiffTimeDescending = (a, b) => {
              const aHasValidTime = a.diffTime && a.diffTime !== "-" && a.diffTime !== null && a.diffTime !== undefined;
              const bHasValidTime = b.diffTime && b.diffTime !== "-" && b.diffTime !== null && b.diffTime !== undefined;

              if (!aHasValidTime && bHasValidTime) return 1;
              if (aHasValidTime && !bHasValidTime) return -1;
              if (!aHasValidTime && !bHasValidTime) return 0;

              const timeA = parseTimeToSeconds(a.diffTime);
              const timeB = parseTimeToSeconds(b.diffTime);
              return timeB - timeA;
            };

            const matchesSearch = (detail) => {
              if (!searchQuery) return true;
              const query = searchQuery.toLowerCase();
              if (detail.name.toLowerCase().includes(query)) return true;
              if (detail.file && detail.file.toString().toLowerCase().includes(query)) return true;
              if (detail.email && detail.email.toLowerCase().includes(query)) return true;
              return false;
            };

            const sortedAllItems = items.filter(matchesSearch).sort(sortByDiffTimeDescending);

            return (
              <div className="col-md-3" key={index}>
                <div className="card latest-update-card update-card">
                  <div className="card-header" style={{ padding: "8px 12px" }}>
                    <div style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      width: "100%"
                    }}>
                      <h5 style={{ margin: 0 }}>
                        {teamType}
                      </h5>
                      <div style={{
                        display: "flex",
                        gap: "6px",
                        fontSize: "11px"
                      }}>
                        <span>Total: {items.length}</span>
                        <span>Active: {items.filter(item => item.userStatus === 0).length}</span>
                        <span>Working: {items.filter(item =>
                          item.userStatus === 0 &&
                          item.file != 0 &&
                          item.diffTime &&
                          item.diffTime !== "-" &&
                          item.diffTime !== "- "
                        ).length}</span>
                      </div>
                    </div>
                  </div>

                  <div
                    className="new-scroll ps--active-y"
                    style={{ height: "850px", position: "relative", overflowY: "scroll" }}
                  >
                    <div className="card-body" style={{ padding: "8px" }}>
                      <div className="latest-update-box">
                        {sortedAllItems.map((detail, detailIndex) => {
                          let iconClass = "";
                          let iconBgColor = "";
                          if (detail.userStatus === 1) {
                            iconClass = "feather icon-x f-w-600 update-icon";
                            iconBgColor = "bg-c-red";
                          } else if (detail.userStatus === 0 && detail.file != null) {
                            iconClass = "feather icon-check f-w-600 update-icon";
                            iconBgColor = "bg-c-green";
                          }

                          const isExpanded = expandedUserId === detail.id;

                          return (
                            <div key={detailIndex}>
                              {/* Main user row */}
                              <div
                                className="row"
                                style={{
                                  margin: "18px 0px 10px 0px",
                                  padding: "4px 0",
                                  borderBottom: isExpanded ? "none" : "1px solid #f0f0f0",
                                }}
                              >
                                <div
                                  className="col-auto text-right update-meta"
                                  style={{ paddingRight: "5px", marginLeft: "-12px" }}
                                >
                                  <i
                                    className={`${iconClass} ${iconBgColor}`}
                                    style={{ fontSize: "12px", width: "20px", height: "20px", lineHeight: "20px" }}
                                  ></i>
                                </div>
                                <div className="col p-l-5" style={{ paddingLeft: "5px" }}>
                                  <h6 className="m-0" style={{ fontSize: "12px", lineHeight: "1.3" }}>
                                    {detail.name} {detail.user_grade ? `- (${detail.user_grade})` : ""}
                                    <br />
                                    <span
                                      style={{
                                        color: detail.in_shift == 1 ? "green" : "red",
                                        fontSize: "12px",
                                      }}
                                    >
                                      <div
                                        className="row"
                                        style={{ margin: 0, display: "flex", alignItems: "center" }}
                                      >
                                        <div
                                          className="col-7 text-left update-meta align-items-center"
                                          style={{ padding: 0, color: "#888a8c", fontStyle: "italic" }}
                                        >
                                          {detail.shift_start} - {detail.shift_end}
                                        </div>
                                        {detail.total_lod > 0 && (
                                          <div
                                            className="col-5 text-right d-flex justify-content-end align-items-center"
                                            style={{ padding: 0, gap: "3px" }}
                                          >
                                            <span
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px",
                                                color: "black",
                                                backgroundColor: "#d1d1d1",
                                                width: "22px",
                                                height: "22px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                lineHeight: "1",
                                              }}
                                            >
                                              {detail.not_related_lod}
                                            </span>
                                            <span
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px",
                                                color: "black",
                                                backgroundColor: "#c4fec6",
                                                width: "22px",
                                                height: "22px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                lineHeight: "1",
                                              }}
                                            >
                                              {detail.total_lod}
                                            </span>
                                            <span
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "12px",
                                                color: "black",
                                                backgroundColor: "#ffadad",
                                                width: "22px",
                                                height: "22px",
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center",
                                                borderRadius: "50%",
                                                lineHeight: "1",
                                              }}
                                            >
                                              {detail.pending_lod}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </span>
                                  </h6>
                                  {detail.file ? (
                                    <div style={{ fontSize: "12px", marginTop: "2px" }}>
                                      <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "100%"
                                      }}>
                                        <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "4px" }}>
                                          <span
                                            style={{
                                              fontWeight: "bold",
                                              cursor: "pointer",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "6px",
                                            }}
                                          >
                                            <span
                                              title="Copy file number"
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                navigator.clipboard.writeText(detail.file);
                                                ToastsStore.success("File Number Copied.")
                                              }}
                                              style={{
                                                cursor: "pointer",
                                                fontSize: "14px",
                                                color: "#64748b",
                                              }}
                                            >
                                              <FileCopyOutlined
                                                fontSize="inherit"
                                                style={{ color: "#b2b2b2", fontSize: "14px" }}
                                                titleAccess="Copy file number"
                                              />
                                            </span>
                                            <span>{detail.file_type ? detail.file_type : "-"} -</span>
                                            <span
                                              onClick={() => this.goToFileDashboardbytrack(detail.file)}
                                              onMouseEnter={(e) => (e.currentTarget.style.textDecoration = "underline")}
                                              onMouseLeave={(e) => (e.currentTarget.style.textDecoration = "none")}
                                            >
                                              {detail.file}
                                            </span>
                                            <span>-</span>
                                          </span>
                                          <span style={{ fontWeight: "bold", color: "#0b00ff", fontSize: "12px" }}>
                                            {detail.diffTime && detail.diffTime !== "- "
                                              ? ` (${detail.taken_filegrade}) - ${detail.diffTime}`
                                              : "-"}
                                          </span>
                                        </div>

                                        {/* Queue Toggle Icon */}
                                        <div style={{ display: "flex", alignItems: "center" }}>
                                          <span style={{ fontSize: "12px", color: "#0b00ff", fontWeight: "bold" }}>{detail.q_count}</span>
                                          <span
                                            style={{
                                              cursor: "pointer",
                                              fontSize: "16px",
                                              color: isExpanded ? "#ff5722" : "#4a90e2",
                                              marginLeft: "4px",
                                              flexShrink: 0,
                                              transition: "transform 0.2s",
                                              transform: isExpanded ? "rotate(90deg)" : "none",
                                            }}
                                            onClick={(e) => this.toggleUserExpand(detail.id, e)}
                                            title={"Show queue"}
                                          >
                                            <i className="feather icon-chevron-right"></i>
                                          </span>
                                        </div>
                                      </div>
                                    </div>
                                  ) : (detail.overall_ideal_time?.formatted != "" ? <div style={{ display: "flex", justifyContent: "space-between", gap: "6px", marginTop: "2px" }}>
                                    <div style={{ fontSize: "12px", marginTop: "2px", fontWeight: 600, color: "#ff7272" }}>
                                      {detail.overall_ideal_time.formatted}
                                    </div>
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                      <span style={{ fontSize: "12px", color: "#0b00ff", fontWeight: "bold" }}>{detail.q_count}</span>
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "16px",
                                          color: isExpanded ? "#ff5722" : "#4a90e2",
                                          marginLeft: "4px",
                                          flexShrink: 0,
                                          transition: "transform 0.2s",
                                          transform: isExpanded ? "rotate(90deg)" : "none",
                                        }}
                                        onClick={(e) => this.toggleUserExpand(detail.id, e)}
                                        title={"Show queue"}
                                      >
                                        <i className="feather icon-chevron-right"></i>
                                      </span>
                                    </div>
                                  </div>
                                    :
                                    <div style={{ display: "flex", justifyContent: "space-between", gap: "6px", marginTop: "2px" }}>
                                      <div style={{ fontSize: "12px", marginTop: "2px" }}>-</div>
                                      <div style={{ display: "flex", alignItems: "center" }}>
                                        <span style={{ fontSize: "12px", color: "#0b00ff", fontWeight: "bold" }}>{detail.q_count}</span>
                                        <span
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "16px",
                                            color: isExpanded ? "#ff5722" : "#4a90e2",
                                            marginLeft: "4px",
                                            flexShrink: 0,
                                            transition: "transform 0.2s",
                                            transform: isExpanded ? "rotate(90deg)" : "none",
                                          }}
                                          onClick={(e) => this.toggleUserExpand(detail.id, e)}
                                          title={"Show queue"}
                                        >
                                          <i className="feather icon-chevron-right"></i>
                                        </span>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {/* Expanded Queue Section */}
                              {isExpanded && (
                                <div
                                  style={{
                                    marginLeft: "30px",
                                    marginRight: "5px",
                                    marginBottom: "15px",
                                    padding: "2px",
                                    backgroundColor: "#f8f9fa",
                                    borderRadius: "4px",
                                    // borderLeft: "3px solid #4a90e2",
                                    fontSize: "12px",
                                  }}
                                >
                                  <div style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "8px",
                                    fontWeight: "bold",
                                    color: "#333"
                                  }}>
                                    <span>
                                      Completed Work - {queueData.Completed_file_count ?? 0}
                                      {queueData?.completed_file_time?.total_time_raw ? ` - (${queueData.completed_file_time.total_time_raw})` : ""}
                                    </span>
                                    {queueLoading && <i className="fa fa-spinner fa-spin"></i>}
                                  </div>

                                  {!queueLoading && queueData && queueData.data && queueData.data.length > 0 ? (
                                    <div style={{ width: "100%" }}>
                                      {/* Header row */}
                                      <div style={{
                                        display: "grid",
                                        gridTemplateColumns: "26px 1fr 80px",
                                        alignItems: "center",
                                        padding: "5px 10px",
                                        backgroundColor: "#f0f4ff",
                                        borderRadius: "6px 6px 0 0",
                                        borderBottom: "1px solid #dce6ff",
                                      }}>
                                        <span style={{ fontSize: "9px", fontWeight: 700, color: "#8898b0", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center" }}>Sl</span>
                                        <span style={{ fontSize: "9px", fontWeight: 700, color: "#8898b0", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center" }}>File</span>
                                        <span style={{ fontSize: "9px", fontWeight: 700, color: "#8898b0", textTransform: "uppercase", letterSpacing: "0.5px", textAlign: "center" }}>LOD</span>
                                      </div>

                                      {/* Data rows */}
                                      {queueData.data.map((item: any, idx: number) => (
                                        <div
                                          key={idx}
                                          style={{
                                            display: "grid",
                                            gridTemplateColumns: "26px 1fr 80px",
                                            alignItems: "center",
                                            padding: "7px 10px",
                                            backgroundColor: idx % 2 === 0 ? "#ffffff" : "#f8faff",
                                            borderBottom: idx < queueData.data.length - 1 ? "1px solid #eef1f7" : "none",
                                            cursor: "pointer",
                                            transition: "background 0.15s",
                                          }}
                                          onMouseEnter={e => (e.currentTarget.style.backgroundColor = "#eef3ff")}
                                          onMouseLeave={e => (e.currentTarget.style.backgroundColor = idx % 2 === 0 ? "#ffffff" : "#f8faff")}
                                        >
                                          {/* Sl No */}
                                          <span style={{ fontSize: "10px", fontWeight: 600, color: "#b8c4d8", textAlign: "center" }}>
                                            {idx + 1}
                                          </span>

                                          {/* File ID */}
                                          <span style={{
                                            fontSize: "11px",
                                            fontWeight: 600,
                                            color: "#2255cc",
                                            letterSpacing: "0.1px",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            textAlign: "center",
                                          }}>
                                            {item.file_id}
                                          </span>

                                          {/* LOD Badges */}
                                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}>
                                            {item.total_lod > 0 ? (
                                              <>
                                                <span title="Not Related" style={{
                                                  fontSize: "10px", fontWeight: 700, color: "#555",
                                                  backgroundColor: "#e2e5ea",
                                                  width: "20px", height: "20px",
                                                  display: "flex", alignItems: "center", justifyContent: "center",
                                                  borderRadius: "50%", lineHeight: "1", flexShrink: 0,
                                                }}>
                                                  {item.not_related_lod}
                                                </span>
                                                <span title="Total LOD" style={{
                                                  fontSize: "10px", fontWeight: 700, color: "#1a7a1a",
                                                  backgroundColor: "#d4f5d4",
                                                  width: "20px", height: "20px",
                                                  display: "flex", alignItems: "center", justifyContent: "center",
                                                  borderRadius: "50%", lineHeight: "1", flexShrink: 0,
                                                }}>
                                                  {item.total_lod}
                                                </span>
                                                <span title="Pending LOD" style={{
                                                  fontSize: "10px", fontWeight: 700, color: "#c0392b",
                                                  backgroundColor: "#ffe0de",
                                                  width: "20px", height: "20px",
                                                  display: "flex", alignItems: "center", justifyContent: "center",
                                                  borderRadius: "50%", lineHeight: "1", flexShrink: 0,
                                                }}>
                                                  {item.pending_lod}
                                                </span>
                                              </>
                                            ) : (
                                              <span style={{ fontSize: "10px", color: "#ccc", fontStyle: "italic" }}>—</span>
                                            )}
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : !queueLoading && (
                                    <div style={{
                                      padding: "18px 10px",
                                      textAlign: "center",
                                      color: "#b0bac8",
                                      fontSize: "11px",
                                      fontStyle: "italic",
                                      backgroundColor: "#f8faff",
                                      borderRadius: "6px",
                                      border: "1px dashed #d6e0ff",
                                    }}>
                                      No files in queue
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          );
                        })}
                        {sortedAllItems.length === 0 && <div className="text-center p-3">No items found</div>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          }
          return null;
        })}
      </>
    );
  };

  // Main render method
  render() {
    const user: any = localStorage.getItem("user");
    const userDetails = user ? JSON.parse(user) : "";
    const isAdmin = (userDetails.role_id === "1" || userDetails.role_id === "2") && userDetails.roleType != "5";

    const {
      eodFromDate,
      eodToDate,
      lhBranchShow,
      lawBranchName,
      bankName,
      showBank,
      selectVal,
      lawhandsBranches,
      banks,
      filteredBranches,
      filteredProduct,
      activeTab,
      selectedTabs,
      isLoading,
      isSearchLoading,
      pageDynamic,
    } = this.state;

    // Get visible tabs for current user role
    const visibleTabs = this.getVisibleTabsForCurrentRole();
    const visibleTabIds = visibleTabs.map(tab => tab.id);

    // Get current selected values for display (filtered by role visibility)
    const currentSelectedValues = selectedTabs
      .filter(id => visibleTabIds.includes(id))
      .map(id => ({
        value: id,
        label: this.tabsConfig.find(tab => tab.id === id)?.label || id
      }));

    return (
      <div className="pcoded-main-container">
        <div className="pcoded-wrapper">
          <div className="pcoded-content">
            <div className="pcoded-inner-content">
              <div className="main-body">
                <div className="page-wrapper">
                  <div className="row pr-3 pl-3">

                    {/* Filter Section */}
                    <div className="col-sm-12">
                      <div className="card">
                        <div className="card-body">
                          <div className="row">
                            {/* Date Filters */}
                            <div className="col-xl-3 col-md-3">
                              <h6>From</h6>
                              <DatePicker
                                format={"DD.MM.YYYY"}
                                disabledDate={this.disabledDate}
                                onChange={(date, dateStr) =>
                                  this.handleDateChange(date, dateStr, "eodFromDate")
                                }
                                style={{ height: "39px", width: "100%" }}
                              />
                            </div>
                            <div className="col-xl-3 col-md-3">
                              <h6>To</h6>
                              <DatePicker
                                format={"DD.MM.YYYY"}
                                disabledDate={this.disabledDate}
                                onChange={(date, dateStr) =>
                                  this.handleDateChange(date, dateStr, "eodToDate")
                                }
                                style={{ height: "39px", width: "100%" }}
                              />
                            </div>

                            <div className="col-xl-3 col-md-3">
                              <h6>LH Branch</h6>
                              {lhBranchShow ? (
                                <Select
                                  isMulti
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  options={this.getLawHandsBranchOptions()}
                                  name="lawHandsBranch"
                                  value={this.getSelectedLawHandsBranchOptions()}
                                  onChange={(e) => this.handleChange1(e, "lawHandsBranch", "multiselect")}
                                />
                              ) : (
                                <select
                                  className="custom-select"
                                  id="lawhands_branch"
                                  name="lawhands_branch"
                                  onClick={() => this.lawBranchName(2)}
                                  onChange={this.handleChange}
                                >
                                  <option value="">Select</option>
                                  {lawhandsBranches && lawhandsBranches.length
                                    ? lawhandsBranches.map((lawBranch: any, index: number) => (
                                      <option key={index} value={lawBranch.id}>
                                        {lawBranch.name}
                                      </option>
                                    ))
                                    : ""}
                                </select>
                              )}
                            </div>

                            <div className="col-xl-3 col-md-3">
                              <h6>Bank Name</h6>
                              {showBank ? (
                                <Select
                                  options={this.getBankOptions()}
                                  name="bank_private_name"
                                  value={this.getBankOptions().find((o: any) => o.value === this.state.bank_private_name)}
                                  onChange={(e) => this.handleChange1(e, "bank_private_name", "singleselect")}
                                />
                              ) : (
                                <select
                                  className="custom-select"
                                  id="bank_name"
                                  name="bank_name"
                                  onClick={() => this.bankName(2)}
                                  onChange={this.handleChange}
                                >
                                  <option value="">Select</option>
                                  {banks && banks.length
                                    ? banks.map((bank: any, index: number) => (
                                      <option key={index} value={bank.id}>
                                        {bank.name}
                                      </option>
                                    ))
                                    : ""}
                                </select>
                              )}
                            </div>
                          </div>

                          {/* Existing filter dropdowns */}
                          <div className="row mt-3">

                            <div className="col-xl-3 col-md-3">
                              <h6>Product</h6>
                              <Select
                                options={this.getProductOptions()}
                                name="product_id"
                                value={this.getProductOptions().find((o: any) => o.value === this.state.product_id)}
                                onChange={(e) => this.handleChange1(e, "product_id", "singleselect")}
                              />
                            </div>

                            <div className="col-xl-3 col-md-3">
                              <h6>Bank Branch</h6>
                              <Select
                                options={this.getBankBranchOptions()}
                                name="branch"
                                value={this.getBankBranchOptions().find((o: any) => o.value === this.state.branch)}
                                onChange={(e) => this.handleChange1(e, "branch", "singleselect")}
                              />
                            </div>

                            {/* Search Button */}
                            <div className="col-xl-2 col-md-2 d-flex align-items-end">
                              <button
                                type="submit"
                                className="btn btn-primary w-100"
                                onClick={() => this.getEodTableData("search")}
                                disabled={isSearchLoading}
                              >
                                {isSearchLoading ? (
                                  <i className="fa fa-spinner fa-spin"></i>
                                ) : (
                                  "Search"
                                )}
                              </button>
                            </div>
                          </div>

                          <div className="row mt-3">
                            <div className="col-sm-12 col-md-12">
                              {/* Tab Multi-Select Dropdown - Show to ALL users, but only show options they have permission for */}
                              {visibleTabs.length > 1 && (
                                <>
                                  <h6>Select Reports to Display</h6>
                                  <Select
                                    isMulti
                                    options={this.getTabOptionsWithSelectAll()}
                                    value={currentSelectedValues}
                                    onChange={this.handleSelectAllChange}
                                    placeholder="Select reports..."
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    menuPortalTarget={document.body}
                                    styles={{
                                      control: (base) => ({
                                        ...base,
                                        minHeight: "39px",
                                      }),
                                      menuPortal: (base) => ({
                                        ...base,
                                        zIndex: 9999
                                      }),
                                      menu: (base) => ({
                                        ...base,
                                        zIndex: 9999,
                                        position: 'absolute'
                                      }),
                                      option: (base, state) => ({
                                        ...base,
                                        backgroundColor: state.isSelected ? '#e6f3ff' : base.backgroundColor,
                                        color: '#000',
                                        fontWeight: state.data.value === 'select-all' ? 'bold' : 'normal',
                                        borderBottom: state.data.value === 'select-all' ? '1px solid #ddd' : 'none',
                                      }),
                                      groupHeading: (base) => ({
                                        ...base,
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        color: '#666',
                                        textTransform: 'none',
                                        padding: '8px 12px',
                                        margin: 0,
                                        backgroundColor: '#f9f9f9',
                                        borderBottom: '1px solid #eaeaea',
                                      })
                                    }}
                                    formatGroupLabel={(group) => (
                                      <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        width: '100%'
                                      }}>
                                        <span>{group.label}</span>
                                        {group.label === 'Select All' && (
                                          <span style={{ fontSize: '12px', color: '#666', fontStyle: 'italic' }}>
                                            Click to select/deselect all
                                          </span>
                                        )}
                                      </div>
                                    )}
                                  />
                                  <small className="text-muted">
                                    {selectedTabs.length === 1 && selectedTabs[0] === 'eod' ?
                                      'Default: Only Login Report is visible' :
                                      `${selectedTabs.length} report(s) selected`}
                                  </small>
                                </>
                              )}

                              {/* Show message if user has only one report option */}
                              {visibleTabs.length === 1 && (
                                <div className="alert alert-info mt-2">
                                  <small>
                                    <i className="feather icon-info mr-1"></i>
                                    You have access to: {visibleTabs[0].label}
                                  </small>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <div className="col-sm-12">
                      <WorkCountTable
                        isLoading={this.state.isLoading}
                        title="Work Count Analysis"
                      />
                    </div> */}

                    {/* Dynamic Tables Rendering - only render if tab is both selected AND visible for role */}
                    {selectedTabs.includes('eod') && visibleTabIds.includes('eod') && this.renderEODTable()}
                    {selectedTabs.includes('queryValidation') && visibleTabIds.includes('queryValidation') && this.renderQueryValidationTable()}
                    {selectedTabs.includes('queryMail') && visibleTabIds.includes('queryMail') && this.renderQueryMailTable()}
                    {selectedTabs.includes('vetting') && visibleTabIds.includes('vetting') && this.renderVettingTable()}
                    {selectedTabs.includes('deviationTracker') && visibleTabIds.includes('deviationTracker') && this.renderDeviationTrackerTable()}
                    {selectedTabs.includes('rectification') && visibleTabIds.includes('rectification') && this.renderRectificationTable()}
                    {selectedTabs.includes('deviation') && visibleTabIds.includes('deviation') && this.renderDeviationTable()}

                    {/* Conditional Tables with special conditions */}
                    {selectedTabs.includes('myTeam') && visibleTabIds.includes('myTeam') &&
                      this.state.autoAssign?.find((data: any) => data.module_name === "Auto Assign" && data.status) &&
                      this.state.myteamdetails &&
                      this.state.teamDetailsData?.length > 0 &&
                      this.renderMyTeamTable()
                    }

                    {selectedTabs.includes('branchLogin') && visibleTabIds.includes('branchLogin') && isAdmin && this.renderBranchLoginTable()}

                    {/* Team Tracking Tabs */}
                    {selectedTabs.includes('teamTracking') && visibleTabIds.includes('teamTracking') && this.renderTeamTracking()}
                    {selectedTabs.includes('fileGrade') && visibleTabIds.includes('fileGrade') && this.renderFileGradeTracking()}

                    {/* OUT REASON MODAL - unchanged */}
                    <div
                      className="modal fade hide in"
                      id="out_reason"
                      data-backdrop="static"
                      data-keyboard="false"
                    >
                      <div className="modal-dialog ">
                        <div
                          className="modal-content"
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0 0 15px #000",
                          }}
                        >
                          <div
                            className="modal-body"
                            style={{ padding: "30px 23px 29px 24px" }}
                          >
                            <h3 style={{ margin: "auto", fontSize: "17px" }}>
                              Please Select The Reason For To Close The File.No:
                              {localStorage.getItem("currentfileId")}
                            </h3>
                          </div>
                          <div
                            className="form-group"
                            style={{ width: "74%", margin: "auto" }}
                          >
                            <select
                              className="custom-select"
                              name="outreason"
                              value={this.state.outreason}
                              onChange={(e) => this.onchangeReason(e)}
                              required
                              id="select1"
                              style={{ marginTop: "8px" }}
                            >
                              <option value="select">Select Your Reason</option>
                              <option value="Query Raised">Query Raised</option>
                              <option value=" Re-Query Raised">
                                {" "}
                                Re-Query Raised
                              </option>
                              <option value="Hold ">Hold </option>
                              <option value="Completed">Completed</option>
                              <option value="Other">Others</option>
                            </select>
                            {selectVal ? (
                              <p
                                style={{
                                  color: "red",
                                  textAlign: "center",
                                  fontSize: "16px",
                                }}
                              >
                                Please Select Your Reason{" "}
                              </p>
                            ) : null}
                          </div>
                          <div
                            className="modal-footer"
                            style={{ marginTop: "27px" }}
                          >
                            <button
                              type="button"
                              className="btn btn-primary"
                              disabled={this.state.isLoading}
                              onClick={this.outimeGet}
                              style={{ width: "76px", fontSize: "17px" }}
                            >
                              {this.state.isLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                "OK"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline"
                              onClick={this.BacktoFile}
                              style={{
                                width: "107px",
                                fontSize: "14px",
                                border: "1px solid black",
                                height: "43px",
                              }}
                            >
                              {" "}
                              Back To File
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* OTHER REASON MODAL - unchanged */}
                    <div
                      className="modal hide fade in"
                      id="another-reason"
                      data-backdrop="static"
                      data-keyboard="false"
                    >
                      <div className="modal-dialog ">
                        <div
                          className="modal-content"
                          style={{
                            borderRadius: "10px",
                            boxShadow: "0 0 15px #000",
                          }}
                        >
                          <h5
                            style={{ marginTop: "31px", textAlign: "center" }}
                          >
                            Please Type a Reason To Close The File.No:{" "}
                            {localStorage.getItem("currentfileId")}{" "}
                          </h5>
                          <div
                            className="modal-body"
                            style={{ padding: "30px 23px 29px 24px" }}
                          >
                            <div
                              className="form-group"
                              style={{ width: "98%", margin: "auto" }}
                            >
                              <textarea
                                className="form-control"
                                placeholder="Type Your Reason"
                                name="outreason"
                                onChange={this.onchange}
                              />
                              {selectVal ? (
                                <p
                                  style={{
                                    color: "red",
                                    textAlign: "center",
                                    fontSize: "16px",
                                  }}
                                >
                                  Please Select Your Reason{" "}
                                </p>
                              ) : null}
                            </div>
                          </div>
                          <div className="modal-footer">
                            <button
                              type="button"
                              className="btn btn-primary"
                              onClick={() => this.outimeGet()}
                              style={{ width: "76px", fontSize: "17px" }}
                              disabled={this.state.isLoading}
                            >
                              {this.state.isLoading ? (
                                <i className="fa fa-spinner fa-spin"></i>
                              ) : (
                                "OK"
                              )}
                            </button>
                            <button
                              type="button"
                              className="btn btn-outline"
                              onClick={() => this.previousPop()}
                              style={{
                                width: "76px",
                                fontSize: "17px",
                                border: "1px solid black",
                              }}
                            >
                              {" "}
                              Back
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;